import { Typography } from "@mui/material";
import { InfoWindow, Marker } from "@react-google-maps/api";
import { useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import { getIconURL } from "../../helper/functions";


export default function OriginMarker({ position }) {
  const [activeInfoWindow, setActiveInfoWindow] = useState(false);

  const handleMouseOver = () => {
    setActiveInfoWindow(true);
  };

  const handleMouseOut = () => {
    setActiveInfoWindow(false);
  };
  return (
    <Marker
      key="map-origin"
      position={position}
      options={{
        icon: {
          url: getIconURL(null, true),
          scaledSize: new window.google.maps.Size(30, 30),
        },
      }}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {activeInfoWindow && (
        <InfoWindow
          position={position}
          options={{
            enableEventPropagation: true,
            disableAutoPan: true,
            pixelOffset: new window.google.maps.Size(0, -20),
          }}
        >
          <div
            style={{
              backgroundColor: HNSColors.neutrals[900],
              padding: "6px 8px",
              borderRadius: "8px",
            }}
          >
            <Typography>Current Address</Typography>
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
}
